export const getRespuestaTexto = respuesta => {
  const info = {
    'very good': 'Muy bueno',
    good: 'Bueno',
    neutral: 'Normal',
    bad: 'Malo',
    'very bad': 'Muy malo'
  }
  return info[respuesta] || respuesta
}

export const getRespuestaIcono = type => {
  const info = {
    'very good': 'sentiment_very_satisfied',
    good: 'sentiment_satisfied',
    neutral: 'sentiment_neutral',
    bad: 'sentiment_dissatisfied',
    'very bad': 'sentiment_very_dissatisfied'
  }
  return info[type] || ''
}

export const QUESTION_TYPES = {
  FACE: 'FACE',
  TEXT: 'TEXT',
  MULTIPLE_CHOICE: 'MULTIPLE_CHOICE',
  SLIDER: 'SLIDER'
}
